import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { color } from '~/assets/styles/colors';

export const StyledLink = styled(Link)`
	height: 60px;
	display: flex;
	align-items: center;
	padding-left: 20px;

	&:hover {
		text-decoration: none;
		background-color: ${color.yellow};
	}
`;
